// Osa Search
import search from "@wk/osa-search-odata3";

// Constants
import {getQueryPriority, ReturnFields} from "constants/gpoSearchEnum";
import { ENVIRONMENT } from "constants/pages";

// Types
import {
	DefaultSearchFieldsWithBoosts,
	FacetSpec,
	FilterByTerm,
	FiltersInterface,
	FilterSpec,
	OsaSearchQuery,
	PropertyValues,
	Query,
	QueryProcessingSpec,
	ResultSpec,
	Sort
} from "interfaces/osaSearch";

const buildFacetSpec = (fieldName: string): FacetSpec => ({
	FacetByField: {
		IncludeMissingFacetCount: false,
		Limit: 10000,
		Offset: 0,
		Prefix: null,
		SortValue: 1
	},
	FacetByHierarchy: null,
	FacetByNumericRange: null,
	FacetTypeValue: 0,
	FieldName: fieldName,
	MinCount: 1
});

const buildFilter = (fieldName: string, terms: string[]): FilterSpec =>
	({
		ComplexFilter: null,
		ExclusionFilter: false,
		FilterByNumericRange: null,
		FilterByQuery: null,
		FilterByTerms: {
			FieldName: fieldName,
			Terms: [...terms]
		} as FilterByTerm,
		FilterTypeValue: 0
	} as FilterSpec);

export const buildQuery = (querySearch: string, filters: FiltersInterface[], sorting: Sort[], pageOffset: number, numberElementsPerPage: any): OsaSearchQuery => ({
	CollectionId: "wki",
	FragmentDocumentValue: null,
	HighlightingEnabled: null,
	HighlightQueryString: null,
	MasterCollection: null,
	PropertyValues: {
		Item: []
	} as PropertyValues,
	Query: {
		AdvFacetSpecs: [],
		FacetSpecs: [buildFacetSpec(ReturnFields.TAG_ID)],
		// @ts-ignore
		FilterSpecs: [buildFilter(ReturnFields.ENVIRONMENT, [ENVIRONMENT]), ...filters.map((filter) => buildFilter(filter.fieldName, filter.terms))],
		FuzzySearch: true,
		QueryProcessingSpec: {
			ApplySynonymExpansion: null,
			DefaultOperatorValue: null,
			DefaultSearchFieldsWithBoosts: {
				Item: getQueryPriority()
			} as DefaultSearchFieldsWithBoosts,
			FieldedSearchTranslations: null,
			PassthruParams: [],
			QueryAdjustments: [],
			QueryLanguage: "it",
			RemoveStopwords: null
		} as QueryProcessingSpec,
		ResultSpec: {
			AdvancedReturnFields: [],
			FilterGrouping: null,
			FragmentsRows: null,
			FragmentsSortValue: null,
			FragmentsStart: null,
			ResultGrouping: null,
			ReturnFields: Object.values(ReturnFields),
			Rows: numberElementsPerPage,
			Sort: sorting,
			Start: (pageOffset - 1) * numberElementsPerPage
		} as ResultSpec
	} as Query,
	QueryString: querySearch
});

export const buildQueryOnlyTags = (querySearch: string, filters: FiltersInterface[]): OsaSearchQuery => ({
	CollectionId: "wki",
	FragmentDocumentValue: null,
	HighlightingEnabled: null,
	HighlightQueryString: null,
	MasterCollection: null,
	PropertyValues: {
		Item: []
	} as PropertyValues,
	Query: {
		AdvFacetSpecs: [],
		FacetSpecs: [buildFacetSpec(ReturnFields.TAG_ID)],
		// @ts-ignore
		FilterSpecs: [buildFilter(ReturnFields.ENVIRONMENT, [ENVIRONMENT]), ...filters.map((filter) => buildFilter(filter.fieldName, filter.terms))],
		FuzzySearch: true,
		QueryProcessingSpec: {
			ApplySynonymExpansion: null,
			DefaultOperatorValue: null,
			DefaultSearchFieldsWithBoosts: {
				Item: getQueryPriority()
			} as DefaultSearchFieldsWithBoosts,
			FieldedSearchTranslations: null,
			PassthruParams: [],
			QueryAdjustments: [],
			QueryLanguage: "it",
			RemoveStopwords: null
		} as QueryProcessingSpec,
		ResultSpec: {
			AdvancedReturnFields: [],
			FilterGrouping: null,
			FragmentsRows: null,
			FragmentsSortValue: null,
			FragmentsStart: null,
			ResultGrouping: null,
			ReturnFields: [ReturnFields.TAG_NAME, ReturnFields.TAG_ID],
			Rows: 0
		} as ResultSpec
	} as Query,
	QueryString: querySearch
});

export const getPropertyValues = (document: search.DocumentResult, property: string): string[] => {
	const newDoc: search.DocumentResult = JSON.parse(JSON.stringify(document));
	return newDoc.documentProperties.find((prop) => prop.fieldName === property)?.fieldValue || [""];
};
